var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "233px",
    height: "233px",
    viewBox: "0 0 233 233",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ubuntu-Dark-Digital") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Domain",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ubuntu-Dark-Digital",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E95420",
    x: 0,
    y: 0,
    width: 232.955,
    height: 232.96,
    rx: 116.4775
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(31.000000, 34.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.268082303,73.4592577 C2.2530823,60.2822577 14.5420823,51.2032577 27.7100823,53.1792577 C40.8960823,55.1562677 49.9740823,67.4442577 47.9900823,80.6212577 C46.0220823,93.7992477 33.7340823,102.876258 20.5480823,100.900258 C7.3790823,98.9242477 -1.6999177,86.6362577 0.268082303,73.4592577",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.025982,19.0751677 C103.821992,6.04415767 116.645982,-2.24783233 129.675972,0.539167666 C142.705972,3.33515767 151.006982,16.1591677 148.211982,29.1891577 C145.416972,42.2201677 132.592982,50.5211577 119.561972,47.7251577 C106.531972,44.9291677 98.2299823,32.1071577 101.025972,19.0751677",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5547823,139.138368 C61.1757823,135.411368 46.6437823,124.311368 38.4797823,108.572368 C32.0427823,111.497368 24.8107823,112.395378 17.8557823,111.109368 C27.7277823,135.375368 48.6797823,152.997368 74.3957823,158.502368 C80.0567823,159.720368 85.8037823,160.307368 91.5337823,160.271368 C87.0977823,154.446368 84.6307823,147.423368 84.4747723,140.096368 C82.4897723,139.880368 80.5057723,139.551368 78.5547723,139.138368",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5894823,134.210368 C98.3854823,121.189368 111.209482,112.888368 124.239482,115.674368 C137.269482,118.470378 145.572492,131.294368 142.776482,144.325368 C139.980472,157.355368 127.156472,165.656368 114.125482,162.860368 C101.095482,160.073368 92.7934823,147.241368 95.5894823,134.210368",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.767882,130.405278 C160.258882,120.955268 165.539882,109.772268 168.094882,97.8792677 C172.529882,77.1622677 168.386892,55.4232677 156.721882,37.7842777 C153.942892,44.3332777 149.213882,49.8742777 143.155892,53.6812777 C149.662892,65.9512677 151.647892,80.1132677 148.729902,93.7302777 C147.297892,100.400278 144.777892,106.683278 141.222902,112.430278 C146.883902,117.089278 150.904892,123.354278 152.767902,130.405278",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2732823,42.4351677 C22.8942823,42.4021677 23.4992823,42.3841777 24.1202823,42.3841777 C26.5542823,42.3841777 28.9872823,42.6421777 31.4042823,43.1601777 C35.3212823,44.0071777 39.0322823,45.5001777 42.4142823,47.5961677 C53.2712723,31.9761677 70.8062823,22.5971777 89.7902823,22.2601677 C89.8942823,20.4401777 90.1362723,18.6191777 90.5152723,16.8231677 C91.6202823,11.6541577 93.8812823,6.82217767 97.1092823,2.68817767 C66.7672823,0.290167666 37.2882823,15.9431677 22.2732823,42.4351677",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.8ecf41dce73dd6ddf0be26fc12005cc9.svg";
export { ForwardRef as ReactComponent };